export const margin = {
    xl: 64,
    l: 32,
    ml: 24,
    m: 16,
    s: 8,
    xs: 4
};
